import React, {useMemo} from "react";
import {renderToStaticMarkup} from "react-dom/server";
import {QRCodeSVG} from "qrcode.react";

/**
 * Cache du markup QR par (valeur + taille). Le QR n'est calculé qu'une seule fois
 * par combinaison distincte ; les copies réutilisent la chaîne mise en cache, ce qui
 * rend l'impression de grands lots fluide.
 */
const qrCache = new Map();

function getQrMarkup(text, size) {
    const key = `${text}|${size}`;
    if (qrCache.has(key)) return qrCache.get(key);
    const markup = renderToStaticMarkup(<QRCodeSVG value={text} size={size} level="M"/>);
    qrCache.set(key, markup);
    return markup;
}

/**
 * Rend un QR code en SVG (avec mise en cache). Retourne null si la valeur est vide.
 */
const QRCodeRenderer = ({value, size = 80, className = ""}) => {
    const text = value == null ? "" : String(value).trim();
    const markup = useMemo(() => (text ? getQrMarkup(text, size) : ""), [text, size]);
    if (!text) return null;
    return (
        <span
            className={className}
            style={{display: "inline-flex"}}
            dangerouslySetInnerHTML={{__html: markup}}
        />
    );
};

export default QRCodeRenderer;
